import React,{useEffect,useState} from "react";
import {Link} from "react-router-dom";
import {api} from "@/lib/api";
import {toast} from "sonner";
export default function QuotationDraftsPage(){
 const [drafts,setDrafts]=useState([]),[busy,setBusy]=useState(false),[error,setError]=useState("");
 const load=()=>api.get("/work-drafts/quotation-list").then(r=>setDrafts(r.data||[])).catch(e=>setError(e.response?.data?.detail||"Could not load quotation drafts"));
 useEffect(()=>{load()},[]);
 const remove=async d=>{
  if(!window.confirm("Discard this unfinished quotation draft? The quotation number is not reserved."))return;
  setBusy(true);
  try{await api.delete("/work-drafts/quotation/"+encodeURIComponent(d.source_id));toast.success("Draft discarded");await load()}
  catch(e){toast.error(e.response?.data?.detail||"Could not discard draft")}finally{setBusy(false)}
 };
 const href=d=>{
  const id=d.source_id||"quotation";
  return id.startsWith("edit-")?"/quotation?edit="+encodeURIComponent(id.slice(5)):
         id==="new"?"/quotes/new":"/quotation";
 };
 return <div className="max-w-3xl mx-auto pb-20 space-y-4">
  <div className="flex flex-wrap items-center justify-between gap-3"><div>
   <h1 className="text-2xl font-semibold">Quotation Drafts</h1>
   <p className="text-sm text-slate-500 mt-1">Resume your unfinished quotation without entering all details again. Form drafts do not reserve a quotation number.</p>
  </div><Link to="/quotes" className="text-sm text-blue-600">Back to quotations</Link></div>
  {error&&<div className="rounded-xl bg-rose-50 p-3 text-sm text-rose-700">{error}</div>}
  <div className="space-y-3">{drafts.map(d=>{
   const p=d.payload||{};const editing=String(d.source_id||"").startsWith("edit-");
   return <div key={d.id} className="fc-card p-4 space-y-2">
    <div className="font-semibold">{p.customer?.customer_name||"Untitled quotation draft"}</div>
    <div className="text-xs text-slate-500">{p.vehicle||"No vehicle selected"} · {p.mainC?"Container selected":"No container selected"}</div>
    <div className="text-xs text-slate-500">Updated {d.updated_at||"—"} · {editing?"Existing quotation edit draft":"New quotation draft"}</div>
    <div className="flex gap-2 flex-wrap"><Link to={href(d)} className="inline-flex h-10 items-center rounded-xl bg-blue-600 px-4 text-sm font-semibold text-white">View / Resume Draft</Link>
      <button type="button" disabled={busy} onClick={()=>remove(d)} className="h-10 rounded-xl border border-rose-200 px-4 text-sm text-rose-700">Discard Draft</button></div>
   </div>;
  })}{!drafts.length&&!error&&<div className="fc-card p-8 text-center text-sm text-slate-500">No saved quotation drafts yet. Open Create Quotation and choose Save Draft at any stage.</div>}</div>
 </div>;
}
